import styled from 'styled-components';

import {trackEvent} from '~/shared/services/analytics';
import {secureOpenWindow} from '~/shared/utils/general';
import orangeLgLogoUrl from '~/assets/images/tenBis-logo.svg';
import {media} from '~/shared/theme/media';
import {flipOnLTR} from '~/shared/theme/utils';

import Button from '../Button';
import ImageWithAlt from '../ImageWithAlt';

import MomentsLogo from './momentsLogo.svg?react';

const MomentsButton = styled(Button)`
  direction: rtl;
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 8px;
  padding: 7px 10px;
  height: 36px;
  border-radius: 52px;
  background-color: ${({theme}) => theme.colors.gray920};
  ${media.minLargeDesktop`
    ${flipOnLTR`
      margin-left: -8px;
    `}
  `}
`;

const StyledWhiteLogoUrl = styled(ImageWithAlt).attrs({
  src: orangeLgLogoUrl,
  alt: '10bis moments',
})`
  width: 68px;
  height: 18px;

  g {
    fill: ${({theme}) => theme.colors.contentBrand};
  }
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;

const StyledMomentsLogo = styled(MomentsLogo).attrs({
  className: 'avoid-fill-stroke',
})`
  top: 2px;
`;

const MOMENTS_URL = 'https://10bis-moments.co.il/';

const Moments = () => {
  const onClick = () => {
    trackEvent('moments_click');
    secureOpenWindow(MOMENTS_URL, '_blank');
  };

  return (
    <MomentsButton onClick={onClick}>
      <Wrapper>
        <StyledWhiteLogoUrl />
        <StyledMomentsLogo />
      </Wrapper>
    </MomentsButton>
  );
};

export default Moments;
